import { render, staticRenderFns } from "./thunmbUpItem.vue?vue&type=template&id=1504d116&scoped=true"
import script from "./thunmbUpItem.vue?vue&type=script&lang=js"
export * from "./thunmbUpItem.vue?vue&type=script&lang=js"
import style0 from "./thunmbUpItem.vue?vue&type=style&index=0&id=1504d116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1504d116",
  null
  
)

export default component.exports